import { type HttpClient } from '../http';

import { type SupportMessagePayload } from './support.types';

/**
 * Writing to support, from the public page.
 *
 * Warning: the only domain of the client that needs **no session**. Somebody
 * who cannot sign in is exactly the person who needs to write, so the route
 * is public — and rate-limited server-side rather than gated here.
 *
 * @param http Transport supplied by the application.
 * @returns The `support` domain of the API client.
 */
export function createSupportApi(http: HttpClient) {
  return {
    /**
     * Sends a request to the support inbox.
     *
     * Answers 202 with no body: the message is taken, and the answer comes by
     * email rather than on screen.
     *
     * @param payload What it is about, where it happens, who to answer, and
     *   the request itself.
     */
    send: (payload: SupportMessagePayload) =>
      http.post<void>('/support/messages', payload),
  };
}

export type SupportApi = ReturnType<typeof createSupportApi>;
